import React from "react";
import RadioButtons from "../../RadioButtons";

const options = [
  { value: "all", label: I18n.t("all") },
  { value: "missing", label: I18n.t("awaiting_entry") },
  { value: "present", label: I18n.t("present") }
];

export default function ResultPresenceInput({ value, onChange }) {
  const handleChange = option => onChange(option.value);
  return (
    <RadioButtons
      name="result_presence"
      onChange={dropDownItem => handleChange(dropDownItem)}
      options={options}
      value={value}
    />
  );
}
